import { createBehavior } from '@area17/a17-behaviors';

const scrollto = createBehavior(
  'scrollto',
  {
    scrollTo($target) {
      let top = 0;

      if ($target) {
        top = $target.getBoundingClientRect().top + window.scrollY;
      }

      window.scrollTo({
        top,
        left: 0,
        behavior: this.options.animate ? 'smooth' : 'auto',
      });
    },
    scrollToTarget() {
      const id =
        this.options.target ?? this.$node.getAttribute('href').slice(1);
      const $target = document.getElementById(id);
      this.scrollTo($target);
    },
    onEvent(evt) {
      evt.preventDefault();
      this.scrollToTarget();
    },
  },
  {
    init() {
      this.options.event = this.options.event ?? 'click';
      this.options.animate = this.options.animate
        ? this.options.animate === 'true'
        : true;
      this.options.livewireEvent = this.options['livewire-event'] ?? null;
      if (this.options.livewireEvent) {
        this.onLivewireEvent = () => {
          this.scrollToTarget();
        };
        if ('Livewire' in window && typeof Livewire.on === 'function') {
          Livewire.on(this.options.livewireEvent, this.onLivewireEvent);
        }
      } else {
        this.$node.addEventListener(this.options.event, this.onEvent);
      }
    },
    destroy() {
      this.$node.removeEventListener(this.options.event, this.onEvent);

      // RYO "Livewire.off"
      if (this.onLivewireEvent && 'Livewire' in window) {
        const { listeners } = Livewire.components.listeners;
        listeners[this.options.livewireEvent] = listeners[
          this.options.livewireEvent
        ].filter((callback) => callback !== this.onLivewireEvent);
      }
    },
  }
);

export default scrollto;
